import React from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import MaintenancePage from './pages/MaintenancePage';
import './App.css';

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/maintenance" element={<MaintenancePage />} />
        <Route path="*" element={<Navigate to="/maintenance" replace />} />
      </Routes>
    </Router>
  );
}
